import { c as _c } from "react/compiler-runtime";
import styled, { css } from 'styled-components';
import { APIDeliveryPolicyGroups } from '../../../../../../../typings/Destination.interface';
import Icon, { StyledIcon } from '../../../common/base/Icon';
import Tooltip from '../../../common/base/Tooltip';
const StyledStackedRateLimitIcon = styled.span<{
  $left: boolean;
}>(({
  theme,
  $left
}) => css`
    display: inline-grid;
    flex: none;
    grid-template-areas: 'stack';
    align-items: end;
    justify-items: center;
    width: ${theme.pxToRem(32)};
    height: ${theme.pxToRem(16)};
    margin-left: ${$left ? theme.spacing(2) : 0};
    cursor: pointer;

    ${StyledIcon} {
      grid-area: stack;
      margin: 0;
      border-radius: 50%;
      background-color: ${theme.colors.surface.base.surface};
    }

    ${StyledIcon}:first-child {
      opacity: 0.6;
      transform: translateX(-8px) scale(0.875);
      transform-origin: center bottom;
      z-index: 1;
    }

    ${StyledIcon}:nth-child(2) {
      box-shadow: 0 0 0 0.5px ${theme.colors.surface.base.surface};
      transform: none;
      z-index: 2;
    }

    ${StyledIcon}:last-child {
      opacity: 0.6;
      transform: translateX(8px) scale(0.875);
      transform-origin: center bottom;
      z-index: 1;
    }
  `);
const DeliveryGroupsIndicator = t0 => {
  const $ = _c(10);
  const {
    groups,
    left: t1
  } = t0;
  const left = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== groups.overrides) {
    t2 = Object.keys(groups.overrides || {});
    $[0] = groups.overrides;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const override_count = t2.length;
  const tooltip = `Delivery groups enabled at ${groups.rate} per ${groups.rate_period} with ${override_count} override${override_count === 1 ? "" : "s"}`;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon icon="rate_limit" muted={true} />;
    t4 = <Icon icon="rate_limit" muted={true} />;
    t5 = <Icon icon="rate_limit" muted={true} />;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== left) {
    t6 = <StyledStackedRateLimitIcon $left={left} role="img" aria-label="Delivery groups enabled">{t3}{t4}{t5}</StyledStackedRateLimitIcon>;
    $[5] = left;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6 || $[8] !== tooltip) {
    t7 = <Tooltip side="bottom" tooltip={tooltip}>{t6}</Tooltip>;
    $[7] = t6;
    $[8] = tooltip;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default DeliveryGroupsIndicator;